import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { DayMonth } from './../_const/const';
import { RegExpIsFloat } from './../_const/const';
import { EditorService } from '@service/editor.service';
import { TranslateService } from '@ngx-translate/core';
import { hasVariable } from '@core/_utils/tools.utils';

@Component({
    selector: 'inputvalue',
    templateUrl: 'inputvalue.component.html',
    styleUrls: ['inputvalue.component.scss'],
})
export class InputValueComponent implements OnInit, OnChanges {
    @Input() public title = '';
    @Input() public dataVariableList;
    @Input() public libAction: boolean = false;
    @Input() public editorService: EditorService;
    @Input() public btnUpdate: boolean = false;
    @Input() public visuMode: boolean = false;
    @Input() public fromReq: boolean = false;
    @Output()
    public onUpdate: EventEmitter<any> = new EventEmitter();

    public firstDayOfWeek: number;
    public isFloat: any;
    public libCol_1: string = 'Variable';
    public libCol_2: string = 'Saisie';
    public displayVar: boolean = false;
    public filtered: any[];

    constructor(private translate: TranslateService) {
        this.libCol_1 = this.translate.instant('Variable');
        this.libCol_2 = this.translate.instant('Ent_Data');
    }

    public ngOnInit() {
        this.firstDayOfWeek = DayMonth.firstDayOfWeek;
        this.isFloat = RegExpIsFloat;
        if (this.libAction === true) {
            this.libCol_1 = this.translate.instant('Actions');
            this.libCol_2 = '';
        }
    }

    public filterItem(event, aItem) {
        let filtered : any[] = [];
        let query = event.query;
        for(let i = 0; i < aItem.comboValue.length; i++) {
            let wCombo = aItem.comboValue[i];
            if (wCombo.displayValue.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(wCombo);
            }
        }        
        this.filtered = filtered;
    }

    public onSelectComplete(value, item, i) {
        if (typeof value === 'string') {
            item.valueCombo = value;
        } else if (value && typeof value === 'object') {
            item.valueCombo = value.retCode ?? value.displayValue ?? '';
        } else {
            item.valueCombo = '';
        }
    }

    public ngOnChanges() {
        if (this.dataVariableList !== undefined) {
            this.updateVariable(this.dataVariableList);
        }
    }

    public update() {
        this.onUpdate.emit();
    }

    private updateVariable(data) {
        this.editorService.updateVariable(data, this.fromReq);
        this.displayVar = hasVariable(this.dataVariableList);
    }

    public onChange($event, item, index) {
        this.editorService.setCustomEditorList(this.editorService.variableListService.customEditorList);
        this.editorService.setValueForUpdate(this.dataVariableList);
        this.dataVariableList = this.editorService.changeDynIndex(this.dataVariableList, item, index);
        this.updateVariable(this.dataVariableList);
    }

    public onClickCmb($event, item, index) {
        this.editorService.setCurrentValue(item.value.retCode, index);
    }

    public onChangeCmbEditable($event, item, index) {
        item.value = $event.value;
    }
}
